import { ServiceHookFactory } from "andculturecode-javascript-react";
import { InstructorTrainingTypeRecord } from "models/view-models/instructors/instructor-training-type-record";

const baseEndpoint = "instructortrainingtypes";
const resourceEndpoint: string = `${baseEndpoint}/:id`;
const resourceType = InstructorTrainingTypeRecord;

// #endregion Constants

// -----------------------------------------------------------------------------------------
// #region Service
// -----------------------------------------------------------------------------------------

const InstructorTrainingTypeService = {
    /**
     * Custom hook for leveraging service create calls in React components
     */
    useCreate: ServiceHookFactory.useCreate(resourceType, baseEndpoint),

    /**
     * Custom hook for leveraging service delete calls in react components
     */
    useDelete: ServiceHookFactory.useDelete(resourceEndpoint),
};

// #endregion Service

// -----------------------------------------------------------------------------------------
// #region Exports
// -----------------------------------------------------------------------------------------

export { InstructorTrainingTypeService };

// #endregion Exports
